import {
    LETTER_A, LETTER_a,
    LETTER_B, LETTER_b,
    LETTER_C, LETTER_c,
    LETTER_D, LETTER_d,
    LETTER_E, LETTER_e,
    LETTER_F, LETTER_f,
    LETTER_G, LETTER_g,
    LETTER_H, LETTER_h,
    LETTER_I, LETTER_i,
    LETTER_J, LETTER_j,
    LETTER_K, LETTER_k,
    LETTER_L, LETTER_l,
    LETTER_M, LETTER_m,
    LETTER_N, LETTER_n,
    LETTER_O, LETTER_o,
    LETTER_P, LETTER_p,
    LETTER_Q, LETTER_q,
    LETTER_R, LETTER_r,
    LETTER_S, LETTER_s,
    LETTER_T, LETTER_t,
    LETTER_U, LETTER_u,
    LETTER_V, LETTER_v,
    LETTER_W, LETTER_w,
    LETTER_X, LETTER_x,
    LETTER_Y, LETTER_y,
    LETTER_Z, LETTER_z,
    LETTER_0, LETTER_1,
    LETTER_2, LETTER_3,
    LETTER_4, LETTER_5,
    LETTER_6, LETTER_7,
    LETTER_8, LETTER_9,
    IMG_LOVE, EMPTY_WEEK,
} from './shared/symbol-array';

export const SYMBOL_MAP = {
    'A': LETTER_A,
    'a': LETTER_a,
    'B': LETTER_B,
    'b': LETTER_b,
    'C': LETTER_C,
    'c': LETTER_c,
    'D': LETTER_D,
    'd': LETTER_d,
    'E': LETTER_E,
    'e': LETTER_e,
    'F': LETTER_F,
    'f': LETTER_f,
    'G': LETTER_G,
    'g': LETTER_g,
    'H': LETTER_H,
    'h': LETTER_h,
    'I': LETTER_I,
    'i': LETTER_i,
    'J': LETTER_J,
    'j': LETTER_j,
    'K': LETTER_K,
    'k': LETTER_k,
    'L': LETTER_L,
    'l': LETTER_l,
    'M': LETTER_M,
    'm': LETTER_m,
    'N': LETTER_N,
    'n': LETTER_n,
    'O': LETTER_O,
    'o': LETTER_o,
    'P': LETTER_P,
    'p': LETTER_p,
    'Q': LETTER_Q,
    'q': LETTER_q,
    'R': LETTER_R,
    'r': LETTER_r,
    'S': LETTER_S,
    's': LETTER_s,
    'T': LETTER_T,
    't': LETTER_t,
    'U': LETTER_U,
    'u': LETTER_u,
    'V': LETTER_V,
    'v': LETTER_v,
    'W': LETTER_W,
    'w': LETTER_w,
    'X': LETTER_X,
    'x': LETTER_x,
    'Y': LETTER_Y,
    'y': LETTER_y,
    'Z': LETTER_Z,
    'z': LETTER_z,
    '0': LETTER_0,
    '1': LETTER_1,
    '2': LETTER_2,
    '3': LETTER_3,
    '4': LETTER_4,
    '5': LETTER_5,
    '6': LETTER_6,
    '7': LETTER_7,
    '8': LETTER_8,
    '9': LETTER_9,
    ' ': EMPTY_WEEK,
    '2764': IMG_LOVE, // '❤️'.charCodeAt(0).toString(16) = 2764 使用Unicode编码代替具体的符号
};
